import axios from "axios";

const TARGETS_API_URL = "agency/admin/targets/";

/* The endpoint takes a batch - { targets: [ ... ] } - so one save covers
   every assignment row on the Add New Target page. */
export const createTargets = async (payload, token) => {
  try {
    const res = await axios.post(TARGETS_API_URL, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
};

/* Only the period, the type and the value are updatable; the user and the
   portfolio a target belongs to are fixed once it exists. */
export const updateTarget = async (id, payload, token) => {
  try {
    const res = await axios.patch(`${TARGETS_API_URL}${id}/`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
};

export const deleteTarget = async (id, token) => {
  try {
    const res = await axios.delete(`${TARGETS_API_URL}${id}/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
};
